import { IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TableCell } from "@material-ui/core";
import { TableRow } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { convertFromTimeStampTToDate } from "../../../../../helpers/TimeConvert";
import { useWebsiteAnnouncementsContext } from "../Components/WebsiteAnnouncementsDataContext";
import { WebsiteAnnouncementsTableActions } from "./ActionFormatter/WebsiteAnnouncementsTableActions";
import moment from "moment";
import { Badge } from "react-bootstrap";
const useStyles = makeStyles((theme) => ({
  greyRatio: {
    color: "black",
    background: "#D3D3D3",
  },
  warningRatio: {
    color: "white",
    background: "#eed202",
  },
  dangerRatio: {
    color: "white",
    background: "#F32013",
  },
  successRatio: {
    color: "white",
    background: "#4BB543",
  },
  tableWrapper: {
    overflowX: "auto",
  },
}));

export default function WebsiteAnnouncementsRow(props) {
  const classes = useStyles();
  const { row, showActions } = props;
  const websiteAnnouncementsContext = useWebsiteAnnouncementsContext();

  return (
    <Fragment>
      <TableRow key={row.announcements_id} hover tabIndex={-1}>
        <TableCell align="center" component="th" scope="row">
          {row.announcements_id}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {row.title}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {row.start_date ? moment(row.start_date, "yyyy-MM-DD").format("yyyy-MM-DD") : "-"}
          {row.end_date
            ? moment(row.end_date, "yyyy-MM-DD").format("- yyyy-MM-DD")
            : ""}
        </TableCell>
        {showActions && (
          <TableCell align="center">
            <WebsiteAnnouncementsTableActions
              row={row}
              openEditWebsiteAnnouncementsPage={
                websiteAnnouncementsContext.openEditWebsiteAnnouncementsPage
              }
            />
          </TableCell>
        )}
      </TableRow>
    </Fragment>
  );
}
